import React from 'react'
import Autosuggest from 'react-autosuggest'

import { Tooltip as ReactTooltip } from 'react-tooltip'

import { Link } from 'pharmacy/src/navigation/link'
import { Header4, Subtitle2 } from 'pharmacy/src/typography'

import { nodeApiSearchItems } from 'mednet-util/src/search'

import _ from 'lodash'

import css from './hintedQuestionInput.scss'

class HintedQuestionInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      value: props.value,
      showTooltip: false,
      suggestions: [],
    }

    this.tooSpecificTooltipRef = React.createRef()
  }

  checkIfQuestionIsCaseBased = (question) => {
    const regexp = /\d+\s*(?:years?[.\-/ ]old|y[.\-/ ]*rs? old|y[.\-/ ]*o)/i

    if (regexp.exec(question)) {
      this.showTooltip()
    } else {
      this.hideTooltip()
    }
  }

  hideTooltip = () => {
    this.setState({ showTooltip: false })
  }

  showTooltip = () => {
    this.setState({ showTooltip: true })
  }

  onChange = (event, { method, newValue }) => {
    if (method === 'type') {
      this.setState({
        value: newValue,
      })
      this.props.onChange(newValue)
      this.checkIfQuestionIsCaseBased(newValue)
    }
  }

  onSuggestionsFetchRequested = _.debounce(async ({ value }) => {
    if (_.isEmpty(value)) {
      this.setState({
        suggestions: [],
      })
      return
    }

    const data = await nodeApiSearchItems('questions', {
      query: value,
      limit: 5,
      statuses: [1],
      searchPlatform: 'LUX',
      trackSearchQuery: false,
    })

    this.setState({
      suggestions: data.items,
    })
  }, 200)

  getSuggestionValue(hit) {
    return hit.question
  }

  renderSuggestionsContainer = ({ containerProps, children }) => {
    const { className, ...restProps } = containerProps
    const classes = [className]

    !(children && this.state.value) &&
      classes.push(css.suggestionsContainerHidden)

    return (
      <div {...restProps} className={classes.join(' ')}>
        <Header4>Similar questions that may have your answer</Header4>
        {children}
      </div>
    )
  }

  renderSuggestion = (hit) => {
    return (
      <Link
        className={css.suggestionLink}
        target="_blank"
        pathname={`/question/${hit.questionId}`}
      >
        <Subtitle2>
          <div className={css.suggestionLinkContent}>{hit.question}</div>
        </Subtitle2>
      </Link>
    )
  }

  renderInputComponent = (inputProps) => {
    return <textarea autoComplete="off" component="textarea" {...inputProps} />
  }

  render() {
    const { inputProps } = this.props
    const { value, showTooltip, suggestions } = this.state

    const theme = {
      sectionContainer: css.sectionContainer,
      sectionContainerFirst: css.sectionContainerFirst,
      sectionTitle: css.sectionTitle,
      suggestion: css.suggestion,
      suggestionsContainer: css.suggestionsContainer,
      suggestionsList: css.suggestionsList,
      input: css.input,
    }

    return (
      <>
        <div
          ref={(ref) => (this.tooSpecificTooltipRef = ref)}
          data-tooltip-id="case-based-tooltip"
        >
          <ReactTooltip
            id="case-based-tooltip"
            effect="solid"
            clickable={false}
            scrollHide={false}
            overridePosition={() => ({ top: -30, left: 0 })}
            className={css.tooltip}
            event="keydown"
            eventOff="fake"
            multiline
          >
            {!showTooltip ? null : (
              <div>
                It looks like you&apos;re trying to ask a case-based question.
                <br />
                Questions should not be case-based or contain any patient
                identifiable information.
              </div>
            )}
          </ReactTooltip>
          <Autosuggest
            getSuggestionValue={this.getSuggestionValue}
            inputProps={{
              ...inputProps,
              value,
              onChange: this.onChange,
            }}
            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
            renderInputComponent={this.renderInputComponent}
            renderSuggestion={this.renderSuggestion}
            renderSuggestionsContainer={this.renderSuggestionsContainer}
            suggestions={suggestions}
            theme={theme}
            alwaysRenderSuggestions
            focusInputOnSuggestionClick
          />
        </div>
      </>
    )
  }
}

export default HintedQuestionInput
